module.exports = __webpack_public_path__ + "static/citzbooking_title-3f0fdae1e8b4bae2497ab7766b9dbab0.png";